import { MARKITAI } from "@markit/common.utils";

// Note: navigator.share only works on https and on mobile
// For desktop, need to use RWebShare
export const onShareLink = async (text: string, url: string) => {
  const shareData = {
    title: "Markit AI",
    text: text,
    url: url,
  };

  try {
    await navigator.share(shareData);
  } catch (err) {
    console.log(`Error: ${err}`);
  }
};

// Fetch the share link domain for the current environment
export const getShareDomain = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3000";
  }
  return MARKITAI;
};
